import { ROUTE_PATH, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class FeedbackMappingMetaModel extends FormMetaModel {
    constructor() {
        super('Add Feedback', ROUTE_PATH.feedbackMappinggrid, ROUTE_PATH.feedbackMapform, 4, '', false, '', 'd-flex align-items-center justify-content-center');
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const title = new SmMetaInputModel(
            'title',
            'title',
            'input',
            true,
            'col-12 col-md-6',
            1,
            1,
            'Title',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            5,

        );

        const students = new SmMetaSelectModel(
            'students',
            'students',
            'ng-select',
            true,
            'col-12',
            1,
            12,
            'Add Student',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'name',
            'id',
            true,
            false,
            false,
            false,
            true

        );

        const batch_id = new SmMetaSelectModel(
            'batch_id',
            'batch_id',
            'select',
            true,
            'col-12 col-md-2',
            1,
            6,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'batch_number',
            'id',

        );

        const feedback_Form_Id = new SmMetaSelectModel(
            'feedback_Form_Id',
            'feedback_Form_Id',
            'ng-select',
            true,
            'col-12 col-md-2',
            1,
            6,
            'Feedback',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            TEMPLATE_OPTIONS,
            'title',
            'id',

        );




        const buttons = {
            submit: new SmBtnMetaModel('Save', '', true, false, true, true),
            isFormControl: false,
        };
        return {
            formInfo,
            buttons,
            title,
            students,
            batch_id,
            feedback_Form_Id,

        }
    }

}